<template>
  <div class="privacy">
    <div class="privacy-wrapper">
      <h2 class="privacy-title">用户协议</h2>
      <h2 class="privacy-title">User Agreement</h2>
      <br />
      <h2 class="s2Title">1. 公司信息</h2>
      <h2 class="s2Title">Company Information</h2>

      <p class="s1">
        本网站由以下机构运营：
        <br /><br />This website is operated by:
      </p>
      <p class="s1">
        公司名称： 香港維珍有限公司
        <br /><br />COMPANY NAME: VEEGEN (HONGKONG) ENTERPRISE COMPANY LIMITED）
        注册地址Registered Address： FLAT/RM 305 3/F YEN SHENG CENTRE 64 HOI YUEN ROAD
        KWUN TONG KL
      </p>

      <h2 class="s2Title">2. 网站的使用</h2>
      <h2 class="s2Title">Use of the Website</h2>

      <p class="s1">
        使用我们的网站即表示您已年满18岁，或在父母或法定监护人的同意和监督下使用本网站。
        <br /><br />By using our website, you confirm that you are at least 18 years old,
        or that you are using the website with the consent and supervision of a parent or
        legal guardian.
      </p>

      <p class="s1">
        您负责维护您的账户信息（包括用户名和密码）的机密性，并对您账户下发生的所有活动承担全部责任。
        <br /><br />You are responsible for maintaining the confidentiality of your
        account information (including your username and password) and for all activities
        that occur under your account.
      </p>

      <p class="s1">
        您同意在使用本网站服务时提供真实、准确、完整的个人信息及寄件信息，并及时更新。
        <br /><br />You agree to provide true, accurate, and complete personal and
        shipping information when using our website’s services, and to keep such
        information updated.
      </p>

      <h2 class="s2Title">3. 服务范围</h2>
      <h2 class="s2Title">Scope of Services</h2>

      <p class="s1">
        我们的网站提供国际快递物流服务，包括但不限于：
        <br /><br />Our website provides international express logistics services,
        including but not limited to:
      </p>

      <p class="s1">
        国际包裹的门到门寄送服务
        <br /><br />International door-to-door parcel delivery
      </p>

      <p class="s1">
        物流状态跟踪查询服务
        <br /><br />Other value-added logistics services
      </p>

      <p class="s1">
        其他相关的物流增值服务
        <br /><br />Other value-added logistics services
      </p>

      <p class="s1">
        我们保留根据运营需要，随时调整服务范围、价格及运输渠道的权利，调整后将通过网站公告或其它方式通知用户。
        <br /><br />We reserve the right to adjust the scope of services, prices, and
        shipping channels at any time based on operational needs. Any adjustments will be
        notified to users via announcements on the website or other means.
      </p>

      <p class="s1">
        需要特别说明的是，本政策不适用于其他第三方向您提供的服务。例如第三方供应链平台依托vTrack向您提供服务时，您向第三方供应链平台提供的个人信息不适用本政策。
        <br /><br />It should be noted that this policy does not apply to services
        provided to you by other third parties. For example, when the third-party supply
        chain platform relies on vTrack to provide services to you, the personal
        information you provide to the third-party supply chain platform does not apply to
        this policy.
      </p>
      <p class="s1">
        一、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然
        人的各种信息。
        <br /><br />1、 The “personal information” here refers to all kinds of information
        recorded electronically or in other ways that can identify a specific natural
        person alone or in combination with other information.
      </p>
      <p class="s1">
        二、个人敏感信息：指包括<span class="high-light"
          >身份证件号码、个人生物识别信息、银行账户、行踪轨迹、交易信息等。</span
        >
        <br /><br />2、 The “personal sensitive information” here refers to personal
        information including ID card number, personal biometric information, bank
        account, whereabouts, transaction information, etc.
      </p>
      <p class="s1">
        三、信息删除：指在实现日常业务功能所涉及的系统中去除信息的行为，使其保持不可被检索、访问的状态。
        <br /><br />3、 The “information deletion” here refers to the act of removing
        information from the system involved in the realization of daily business
        functions, so that it can not be retrieved and accessed.
      </p>
      <p class="s1">
        四、儿童：指<span class="high-light">不满十四周岁的未成年人。</span>
        <br /><br />4、 The “children” here refer to minors under the age of 14.
      </p>
      <p class="s1">
        五、关键公司：是指与我们之间存在直接或间接控制关系或其实际控制人相同或具有重大影响关系的企业。
        <br /><br />5、The “key company” here refers to an enterprise that has a direct or
        indirect control relationship with us or has the same or significant influence
        relationship with its actual controller.
      </p>
      <p class="s1">
        六、除另有约定外，本政策所用定义与《vTrack个人用户服务协议》中的定义具有相同的涵义。
        <br /><br />6、 Unless otherwise agreed, the definitions used in this policy have
        the same meanings as those in the vTrack Individual User Service Agreement.
      </p>

      <div class="noticeBox">
        香港維珍有限公司
        <br />VEEGEN (HONGKONG) ENTERPRISE COMPANY LIMITED <br /><br /><br />Add: FLAT/RM
        305 3/F YEN SHENG CENTRE 64 HOI YUEN ROAD KWUN TONG KL <br /><br /><br />Email:
        pfg@prolinker.top <br /><br />Tel: +86 13535333100
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "vant";

import Vue from "vue";
Vue.use(Button);
export default {
  name: "Privacy",
  data() {
    return {};
  },
  created() {
    const { headerHide } = this.$route.query;
    if (headerHide) {
      this.headerHide = JSON.parse(headerHide);
      if (this.headerHide) {
        document.getElementsByClassName("van-nav-bar")[0].style.display = "none";
      }
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.privacy {
  * {
    font-size: 11px;
  }
  .privacy-wrapper {
    width: 90%;
    margin: auto;
    padding-top: 15px;
    .privacy-title {
      width: 100%;
      text-align: center;
      font-size: 13px;
      margin-top: 5%;
    }
    .titleInfo {
      width: 100%;
      text-align: center;
      margin: 10px 0;
    }
    .info {
      width: 100%;
      text-align: center;
      margin: 25px 0;
    }
    .s1 {
      text-align: left;
      margin: 25px 0;
    }
    .sTitle {
      text-align: left;
      margin-top: 10px;
      margin-bottom: 0px;
    }
    .s2 {
      font-size: 12px;
      text-align: left;
      margin: 25px 0;
    }
    .s2Title {
      font-size: 12px;
      text-align: left;
      margin-top: 10px;
      margin-bottom: 0px;
    }
    .link-button {
      vertical-align: middle;
      margin-left: 2%;
      margin-bottom: 1%;
      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
    }
    .high-light {
      font-weight: bold;
      color: #1d86f7;
    }
    .noticeBox {
      margin: 30% auto 0% auto;
      width: 90%;
      color: #999;
      text-align: center;
    }
  }
}
</style>
